import AppContext from 'App/AppContext';
import { IPText } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { globalStackTokensGapMedium } from 'globalStyles';
import ResourceLink from 'models/resourceLink';
import ResourceList from 'models/resourceList';
import { Fragment, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ResourceLinkDecorationLookup } from './SingleResourceLink';
import SingleTypeResourceList from './SingleTypeResourceList';

interface ILinkList {
  items: ResourceLink[];
  navigateExternal?: boolean;
  readonly: boolean;
  disableEmptyState?: boolean;
  // per link an icon, a status line and the row menu's Details and Replace; the asset list of a Supplier names the
  // certificate a document holds
  getDecoration?: ResourceLinkDecorationLookup;
  onDelete: (item: ResourceLink) => void;
  onPin?: (item: ResourceLink, pinned: boolean) => void;
}

const LinkList = (props: ILinkList) => {
  const appContext = useContext(AppContext);
  const { t } = useTranslation(['translation']);
  const [usedLists, setUsedLists] = useState<ResourceList[]>([]);

  useEffect(() => {
    const ids = props.items.map((i) => i.listId); //get all used list Id's
    const uniqueIds = Array.from(new Set(ids)); //de-duplicate
    const lists = appContext.globalDataCache.lists.getItemsForId(uniqueIds); //get lists from cache for used Id's
    lists.sort((a, b) => a.name.localeCompare(b.name)); //sort on name
    setUsedLists(lists);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.items]);

  //
  // Main render
  //
  return (
    <Fragment>
      {usedLists.length === 0 && !props.disableEmptyState && (
        <IPStack verticalFill horizontalAlign="center" verticalAlign="center">
          <IPText>{t('translation:General.Notifications.NoItems')}</IPText>
        </IPStack>
      )}
      {usedLists.length > 0 && (
        <IPStack tokens={globalStackTokensGapMedium}>
          {usedLists.map((list) => {
            return (
              <IPStack.Item key={list.listId}>
                <SingleTypeResourceList
                  type={list.listType}
                  items={props.items.filter((_itm) => {
                    return _itm.list.listId === list.listId;
                  })}
                  onDelete={props.onDelete}
                  onPin={props.onPin}
                  navigateExternal={props.navigateExternal}
                  readonly={props.readonly}
                  getDecoration={props.getDecoration}
                />
              </IPStack.Item>
            );
          })}
        </IPStack>
      )}
    </Fragment>
  );
};

export default LinkList;
